<template>
  <v-list-item
    :title="t('support-chat')"
    class="ma-0"
    @click="openChat"
    v-if="validEnterpriseClient"
  >
    <template v-slot:prepend>
      <v-icon v-if="!loading">mdi-chat-outline</v-icon>
      <v-progress-circular
        v-else
        :size="25"
        indeterminate
        class="mr-4"
      />
    </template>
  </v-list-item>
  <component :is="Chat" v-if="chatOpen" ref="chatRef"/>

  <CrewSupportModal v-if="showCrewModal" v-model="showCrewModal" />
</template>

<script setup>
import { ref, computed, defineAsyncComponent, watch } from "vue";
import { useRootStore } from "../../../stores/root";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import CrewSupportModal from "../../CrewSupportModal.vue";

const Chat = defineAsyncComponent(() => import("./Chat.vue"));

const store = useRootStore();
const { enterpriseClient, orgId, isCrewMember } = storeToRefs(store);

const { t } = useI18n();

const validEnterpriseClient = computed(() => {
  return ["McDonalds", "TimHortons", "Popeyes"].includes(enterpriseClient.value);
});

const chatOpen = ref(false);
watch(orgId, () => chatOpen.value = false);
const chatRef = ref();
const loading = computed(() => chatRef.value?.loading);
const showCrewModal = ref(false);

function openChat() {
  // Check if user is a crew member and show popup instead
  if (isCrewMember.value) {
    showCrewModal.value = true;
    return;
  }

  chatOpen.value = !chatOpen.value;
  if (chatRef.value?.openZendesk) {
    if (chatOpen.value) {
      chatRef.value.closeZendesk();
    } else {
      chatRef.value.openZendesk();
    }
  }
}

</script>

<i18n>
{
  "en": {
    "support-chat": "Support Chat"
  },
  "es": {
    "support-chat": "Chat de Soporte"
  }
}
</i18n>

<style>

  /* hides zendesk launcher button in bottom right of page */
  #launcher {
    display: none;
  }
</style>
